"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidResourceReasonsEnum = exports.OrderByResourceEnum = void 0;
var OrderByResourceEnum;
(function (OrderByResourceEnum) {
    OrderByResourceEnum["ID"] = "id";
    OrderByResourceEnum["NAME"] = "name";
    OrderByResourceEnum["CREATED_AT"] = "createdAt";
    OrderByResourceEnum["RESOURCE_TYPE"] = "resourceType";
    OrderByResourceEnum["FIRST_NAME"] = "firstName";
    OrderByResourceEnum["LAST_NAME"] = "lastName";
    OrderByResourceEnum["EMAIL"] = "email";
    OrderByResourceEnum["STATUS"] = "status";
})(OrderByResourceEnum = exports.OrderByResourceEnum || (exports.OrderByResourceEnum = {}));
var InvalidResourceReasonsEnum;
(function (InvalidResourceReasonsEnum) {
    InvalidResourceReasonsEnum["FACILITY"] = "facility";
    InvalidResourceReasonsEnum["SPORT"] = "sport";
})(InvalidResourceReasonsEnum = exports.InvalidResourceReasonsEnum || (exports.InvalidResourceReasonsEnum = {}));
//# sourceMappingURL=resources.enums.js.map